import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { t } from '@common/helpers/translator';
import Config from '@skin_config';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';
import { CASHOUT_MONEY_WITH_FEE } from '../../../actions/actionTypes';
import infoPic from '../../../images/info-icon.png';

import './style.scss';

const CashoutByBankCard = () => {
  const dispatch = useDispatch();
  const [, { openPopup }] = useContext(PopupContext);

  return (
    <div className="cashout-card-container">
      <p className="cashout-card-title">{t('Cash Out')}</p>
      <p className="cashout-card-sub-title">{t(`${Config.main.cashoutCommissionPercent}% commission will be charged for cashing. You can transfer money to your account to avoid interest.`)}</p>
      <img alt="info-icon" src={infoPic} />
      <div className="buttons-container">
        {Config.balanceTransfer.enableTransferToUser && (
          <button
            type="button"
            className="button-view-normal-m"
            onClick={() => openPopup(POPUPS.TRANSFER_TO_USER)}
          >
            {t('Transfer To Account')}
          </button>
        )}

        <button
          type="button"
          className="button-view-normal-m cancel"
          onClick={() => dispatch({ type: CASHOUT_MONEY_WITH_FEE })}
        >
          {t('Cash Out')}
        </button>
      </div>
    </div>
  );
};

export default CashoutByBankCard;
